import { render, staticRenderFns } from "./DirectFileUploadControl.vue?vue&type=template&id=07af65e5&scoped=true&"
import script from "./DirectFileUploadControl.vue?vue&type=script&lang=ts&"
export * from "./DirectFileUploadControl.vue?vue&type=script&lang=ts&"
import style0 from "./DirectFileUploadControl.vue?vue&type=style&index=0&id=07af65e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07af65e5",
  null
  
)

export default component.exports